import React from 'react';
import { IconSpinner } from './QuirkIcons';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
interface ContentPreloaderProps {
	message: string;
}

export const ContentPreloaderCompact: React.FC<ContentPreloaderProps> = ({ message }) => {
	return (
		<div className={sharedStyles.noResultsCompact}>
			<div>
				<IconSpinner />
			</div>
			{<div>{message}</div>}
		</div>
	);
};
